import React, { useEffect } from 'react';

import Header from '../header';
import Footer from '../footer';

export default ({ children }) => {
    return (
        <React.Fragment>
            <div className="page-hold flex-shrink-0 flex-grow-1 d-flex flex-column">
                <Header/>
                <main className="main d-flex flex-column flex-grow-1 justify-content-center">
                    {children}
                </main>
            </div>
            <Footer/>
        </React.Fragment>
    );
};
